module.exports = __webpack_public_path__ + "img/emoji-success.b2c82edf.png";